import { useEffect, useRef, useState } from 'react';

const PORTAL_SELECTOR = '[data-portal-modal="true"]';

export function useComponentVisible(initialIsVisible: boolean) {
  const ref = useRef<any>(null);
  const openerRef = useRef<any>(null);
  const [isComponentVisible, setIsComponentVisible] =
    useState(initialIsVisible);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const target = event.target as HTMLElement;

      // If the click lands inside a portal that is different from the portal
      // containing this component's ref, skip — the click belongs to another
      // modal overlay and should not close this component.
      const targetPortal = target.closest(PORTAL_SELECTOR);
      const refPortal = ref.current?.closest(PORTAL_SELECTOR) ?? null;

      if (targetPortal && targetPortal !== refPortal) return;

      const isOutsideContent = !ref.current?.contains(target);
      const isOutsideOpener = !openerRef.current?.contains(target);
      const clickedOutside = ref.current && isOutsideContent && isOutsideOpener;

      if (clickedOutside) {
        setIsComponentVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  return { ref, openerRef, isComponentVisible, setIsComponentVisible };
}
